import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';

export class GastosOperativosModal extends BasePage {

    createPageProperties = (pageApi) => {
        return {
            title: 'Busqueda de Gastos Operativos Coti',
            barHeader: {
                fields:[
                    {...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal()}
                ]
            }
        };
    }
    
    renderPage(pageApi) {
        const getFormGastosOperativos = () => pageApi.getComponent('gastosForm');
        const getGridGastosOperativos = () => pageApi.getComponent('gastosGrid');
        let descripcion_grupo = '';
        let cantidad_puntos = 1;
        let frecuencia = 1;
        let dias = 1;

        const formConfig = {
            layout: 'vertical',
            fields:[
                {type: 'divider', label: 'Ingreso de Grupo'},
                {name:'descripcion_grupo', label:'Descripcion', column: 12, onChange: (value, values) => {  
                    descripcion_grupo = value;
                }},
                { type: 'number', name:'dias', label:'Días', column: 4, value: 1, onChange: (value, values) => {  
                    dias = value;
                }},
                { type: 'number', name:'cantidad_puntos', label:'Cantidad de Puntos', column: 4, value: 1, onChange: (value, values) => {  
                    cantidad_puntos = value;
                }},
                { type: 'number', name:'frecuencia', label:'Frecuencia', column: 4, value: 1, onChange: (value, values) => {  
                    frecuencia = value;
                }},
            ]
        } 

        const gridConfig = {
            title: '',
            rowId: 'id_gasto_operativo',
            showIndex: true,
            autoLoad: true,
            filter: true,
            // selection: {type: SELECTION_TYPE.MULTIPLE},
            load: {
                queryId: 610,
                params: {id_moneda : 1, id_doc: pageApi.getParamId()}
            },
            fields:[

                { name:'descripcion', label:'Gasto Operativo'}, 
                {...COLUMN_DEFAULT.ADD_SQUARE, color:'green', title: 'Seleccionar' , label: 'Opciones', width: 100, onClick: async (value, row) => {
                        
                    await getGridGastosOperativos().saveItemEditing();
                    getGridGastosOperativos().refresh();
                    let gasto_operativo = row;
                    if(descripcion_grupo != ''){
                        let sub_total = parseFloat(cantidad_puntos * frecuencia * dias * gasto_operativo.precio_venta).toFixed(2);
                        let obj_gastos = {...gasto_operativo, descripcion_grupo, cantidad_puntos, frecuencia, dias, sub_total, id_tipo_cliente: 3, tipoClienteDes: 'Seleccione'}
                        pageApi.getEvent('afterAddEvent')(obj_gastos);
                    }
                    else{
                        return MessageUtil('warning','Alerta!','Descripción del Grupo es campo obligatorio!');
                    }
                }
            }
            ]
        };  
    
        return (
            <>
                <FormFw 
                    name="gastosForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig}
                />

                <GridFw 
                    name="gastosGrid" 
                    getParentApi={pageApi.getApi}
                    config={gridConfig}
                />
            </>
        )

    }
    
}